export default __webpack_public_path__ + "static/media/comerica-atticus-app-partner.b868b605.svg";